export const touchpointData = [
  {
    "Premium High Street": [15, 10],
  },
  {
    "Neighbourhood Premium Mall": [20, 20],
  },
  {
    "Golf Course": [20, 5],
  },
  {
    "Arterial Route": [10, 5],
  },
  {
    "Feeder Route": [10, 20],
  },
  {
    "Luxury Residential": [10, 5],
  },
  {
    "Premium F&B Cluster": [5, 10],
  },
  {
    QSR: [4, 10],
  },
  {
    "CBD-Gov": [6, 5],
  },
  {
    "Joggers Park": [10, 10],
  },
];

export const industryTypes = [
  { label: "Agriculture", value: "agriculture" },
  { label: "Automotive", value: "automotive" },
  { label: "Aviation", value: "aviation" },
  { label: "Banking", value: "banking" },
  { label: "Biotechnology", value: "biotechnology" },
  { label: "Chemical", value: "chemical" },
  { label: "Construction", value: "construction" },
  { label: "Consulting", value: "consulting" },
  { label: "Consumer Goods", value: "consumer-goods" },
  { label: "Defense", value: "defense" },
  { label: "Education", value: "education" },
  { label: "Energy", value: "energy" },
  { label: "Entertainment", value: "entertainment" },
  { label: "Fashion", value: "fashion" },
  { label: "Finance", value: "finance" },
  { label: "Food & Beverage", value: "food-beverage" },
  { label: "Healthcare", value: "healthcare" },
  { label: "Hospitality", value: "hospitality" },
  { label: "Information Technology (IT)", value: "information-technology" },
  { label: "Insurance", value: "insurance" },
  { label: "Legal", value: "legal" },
  { label: "Manufacturing", value: "manufacturing" },
  { label: "Media", value: "media" },
  { label: "Mining", value: "mining" },
  { label: "Non-Profit", value: "non-profit" },
  { label: "Pharmaceutical", value: "pharmaceutical" },
  { label: "Real Estate", value: "real-estate" },
  { label: "Retail", value: "retail" },
  { label: "Telecommunications", value: "telecommunications" },
  { label: "Transportation", value: "transportation" },
  { label: "Utilities", value: "utilities" },
  { label: "Wholesale", value: "wholesale" },
  { label: "E-commerce", value: "e-commerce" },
  { label: "Logistics", value: "logistics" },
  { label: "Sports", value: "sports" },
  { label: "Tourism", value: "tourism" },
  { label: "Renewable Energy", value: "renewable-energy" },
  { label: "Artificial Intelligence (AI)", value: "artificial-intelligence" },
  { label: "Blockchain & Cryptocurrency", value: "blockchain-cryptocurrency" },
  { label: "Cybersecurity", value: "cybersecurity" },
  { label: "Gaming", value: "gaming" },
  { label: "Space Technology", value: "space-technology" },
  { label: "Robotics", value: "robotics" },
  { label: "Nanotechnology", value: "nanotechnology" },
  { label: "Maritime", value: "maritime" },
  { label: "Textiles", value: "textiles" },
  { label: "Publishing", value: "publishing" },
  { label: "Advertising", value: "advertising" },
  { label: "Environmental Services", value: "environmental-services" },
  { label: "Forestry", value: "forestry" },
  { label: "Fishing", value: "fishing" },
  { label: "Government", value: "government" },
  { label: "Human Resources", value: "human-resources" },
  { label: "Market Research", value: "market-research" },
  { label: "Public Relations (PR)", value: "public-relations" },
  { label: "Venture Capital", value: "venture-capital" },
  { label: "Private Equity", value: "private-equity" },
  { label: "Cryptocurrency & Blockchain", value: "cryptocurrency-blockchain" },
  { label: "Cloud Computing", value: "cloud-computing" },
  { label: "Data Analytics", value: "data-analytics" },
  { label: "Internet of Things (IoT)", value: "internet-of-things" },
  { label: "Augmented Reality (AR) & Virtual Reality (VR)", value: "ar-vr" },
  { label: "3D Printing", value: "3d-printing" },
  { label: "Drones", value: "drones" },
  { label: "Fitness & Wellness", value: "fitness-wellness" },
  { label: "Pet Care", value: "pet-care" },
  { label: "Event Management", value: "event-management" },
  { label: "Music", value: "music" },
  { label: "Film & Television", value: "film-television" },
  { label: "Theater", value: "theater" },
  { label: "Art & Design", value: "art-design" },
  { label: "Architecture", value: "architecture" },
  { label: "Interior Design", value: "interior-design" },
  { label: "Waste Management", value: "waste-management" },
  { label: "Water Treatment", value: "water-treatment" },
  { label: "Aerospace", value: "aerospace" },
  { label: "Railway", value: "railway" },
  { label: "Shipbuilding", value: "shipbuilding" },
  { label: "Semiconductors", value: "semiconductors" },
  { label: "Electronics", value: "electronics" },
  { label: "Optics", value: "optics" },
  { label: "Jewelry", value: "jewelry" },
  { label: "Luxury Goods", value: "luxury-goods" },
  { label: "Tobacco", value: "tobacco" },
  { label: "Alcohol", value: "alcohol" },
  { label: "Cannabis", value: "cannabis" },
  { label: "Franchising", value: "franchising" },
  { label: "Outsourcing", value: "outsourcing" },
  { label: "Freelancing", value: "freelancing" },
  { label: "Co-working Spaces", value: "co-working-spaces" },
  { label: "PropTech (Property Technology)", value: "proptech" },
  { label: "EdTech (Education Technology)", value: "edtech" },
  { label: "FinTech (Financial Technology)", value: "fintech" },
  { label: "HealthTech (Health Technology)", value: "healthtech" },
  { label: "InsurTech (Insurance Technology)", value: "insurtech" },
  { label: "LegalTech (Legal Technology)", value: "legaltech" },
  { label: "AgriTech (Agricultural Technology)", value: "agritech" },
  { label: "CleanTech (Clean Technology)", value: "cleantech" },
  { label: "GovTech (Government Technology)", value: "govtech" },
  { label: "HRTech (Human Resources Technology)", value: "hrtech" },
  { label: "Other", value: "other" },
];
